import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUIStore = (props?: { breakpoint?: string }) =>
  defineStore('uiStore', () => {
    const isDrawerOpen = ref<boolean>(false)
    const isMobile = ref(false)

    const toggleDrawer = (val: boolean) => (isDrawerOpen.value = val)

    const checkScreenSize = () => {
      const breakpoints: { [key: string]: number } = {
        xs: 576,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1600,
      }

      const breakpointWidth = props?.breakpoint ? breakpoints[props.breakpoint] || 768 : 768
      isMobile.value = window.innerWidth < breakpointWidth
    }

    return {
      isDrawerOpen,
      toggleDrawer,
      openDrawer: () => toggleDrawer(true),
      closeDrawer: () => toggleDrawer(false),

      isMobile,
      checkScreenSize,
    }
  })
